import React from "react";
import MuiTableHead from "@mui/material/TableHead";
import PropTypes from "prop-types";

/**
 * TableHead component wrapper for table header.
 * Wraps Material-UI TableHead with theme integration.
 * 
 * @component
 * @example
 * <TableHead>
 *   <TableRow>
 *     <TableCell>Column Header</TableCell>
 *   </TableRow>
 * </TableHead>
 */
const TableHead = ({ children, ...props }) => {
  return <MuiTableHead {...props}>{children}</MuiTableHead>;
};

TableHead.propTypes = {
  /**
   * The content of the component, normally TableRow
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI TableHead behavior

export default TableHead;

